// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable, of } from 'rxjs';

// Ngrx
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as rememberPass from '../rememberPass/rememberPass.actions';

// Service
import { SoledadAuthenticationService } from '../../../shared/services/b2b/auth.service';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class RememberPassEffects {
    constructor(private authService: SoledadAuthenticationService, private actions$: Actions) {}

    doRemember$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(rememberPass.rememberPassActionTypes.DO_REMEMBER),
            switchMap((action: rememberPass.DoRemember) =>
                this.authService.getNewPassword(action.email, action.returnPath).pipe(
                    map((data) => new rememberPass.DoRememberSuccess(data)),
                    catchError((error) => of(new rememberPass.DoRememberFail(error)))
                )
            )
        )
    );
}
